"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebounce = void 0;
const react_1 = __importDefault(require("react"));
function useDebounce(value, delay = 200) {
    const [debouncedValue, setDebouncedValue] = react_1.default.useState(value);
    react_1.default.useEffect(() => {
        const id = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);
        return () => {
            clearTimeout(id);
        };
    }, [value, delay]);
    return debouncedValue;
}
exports.useDebounce = useDebounce;
